var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaultReportInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FFE64B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2534_21049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4C5.79333 4 4 5.79333 4 8C4 10.2067 5.79333 12 8 12C10.2067 12 12 10.2067 12 8C12 5.79333 10.2067 4 8 4ZM8 11C6.34667 11 5 9.65333 5 8C5 6.34667 6.34667 5 8 5C9.65333 5 11 6.34667 11 8C11 9.65333 9.65333 11 8 11Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 7.66667H8.33334V6C8.33334 5.72333 8.11 5.5 7.83334 5.5C7.55667 5.5 7.33334 5.72333 7.33334 6V8.16667C7.33334 8.44333 7.55667 8.66667 7.83334 8.66667H9.33334C9.61 8.66667 9.83334 8.44333 9.83334 8.16667C9.83334 7.89 9.61 7.66667 9.33334 7.66667Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2534_21049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaultReportInProgress);
export default __webpack_public_path__ + "static/media/fault-report-in-progress.9d0cd37f.svg";
export { ForwardRef as ReactComponent };